import { Document, Packer, Paragraph, TextRun } from "docx";
import { getSystemSampleTemplate } from "./letterDocumentBuilder";

function paragraphFromLine(line = "") {
  const text = String(line);
  const parts = [];
  const re = /(\{\{\s*[a-zA-Z0-9_]+\s*\}\})/g;
  let last = 0;
  let m;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) {
      parts.push(new TextRun({ text: text.slice(last, m.index), size: 22 }));
    }
    parts.push(
      new TextRun({
        text: m[1],
        bold: true,
        font: "Consolas",
        size: 20,
      })
    );
    last = m.index + m[1].length;
  }
  if (last < text.length) {
    parts.push(new TextRun({ text: text.slice(last), size: 22 }));
  }
  if (!parts.length) {
    parts.push(new TextRun({ text: " ", size: 22 }));
  }
  return new Paragraph({
    spacing: { after: 80, line: 276 },
    children: parts,
  });
}

function textToParagraphs(block = "") {
  return String(block || "")
    .replace(/\r\n/g, "\n")
    .split("\n")
    .map((line) => paragraphFromLine(line));
}

/**
 * Build a real .docx from template text only — no added letterhead/titles/guides.
 * Used for sample download and text-template generate fallback.
 */
export async function buildDocxBlobFromTemplateText({
  letterType,
  template,
  bodyText,
}) {
  const sample = template || getSystemSampleTemplate(letterType);
  const text =
    bodyText != null
      ? String(bodyText)
      : [sample?.header, sample?.content, sample?.footer].filter(Boolean).join("\n\n");

  if (!String(text || "").trim()) return null;

  const doc = new Document({
    sections: [
      {
        properties: {
          page: {
            margin: { top: 720, right: 720, bottom: 720, left: 720 },
          },
        },
        children: textToParagraphs(text),
      },
    ],
  });

  return Packer.toBlob(doc);
}

/** @deprecated alias — sample is template body with tags only */
export async function buildSampleFormatDocxBlob({ letterType, template }) {
  return buildDocxBlobFromTemplateText({ letterType, template });
}

export function downloadBlobFile(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export async function arrayBufferFromBlob(blob) {
  return blob.arrayBuffer();
}
